import styled from 'styled-components';
import NonSmokingSvg from '../../assets/amenities/non-smoking.svg';

const NonSmokingIcon = styled(NonSmokingSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default NonSmokingIcon;
